import { useTranslator } from '@Localization';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ColumnLayout } from '../../../../../../modules/common/layouts/columnLayout/ColumnLayout';
import { useClarificationsPermissions } from '../Clarifications.permissions';
import { IClarificationsStore } from '../Clarifications.store';
import { ClarificationsArchiveListContainer } from './ClarificationsArchiveList.container';

export const CurrentClarificationContainer = observer((): ReactElement => {
  const clarificationsStore = useInjection(IClarificationsStore.$);
  const clarificationsPermissions = useClarificationsPermissions();

  const { t } = useTranslator();
  const clarification = clarificationsStore.clarification;
  const canSeePersonalData = clarificationsPermissions.canSeePersonalData().allowed;

  if (!clarification) {
    return <></>;
  }

  return (
    <ColumnLayout
      size='md'
      className='current-clarification'
    >
      {canSeePersonalData && (
        <div>
          <span className='current-clarification-title'>{t('clarifications.common.asked_by')}: </span>
          {clarification.askedBy}
        </div>
      )}
      <div>
        <span className='current-clarification-title'>{t('clarifications.common.question')}: </span>
        {clarification.question}
      </div>
      {canSeePersonalData && clarification.answeredBy && (
        <div>
          <span className='current-clarification-title'>{t('clarifications.common.answered_by')}: </span>
          {clarification.answeredBy}
        </div>
      )}
      {clarification.answer && (
        <div>
          <span className='current-clarification-title'>{t('clarifications.common.answer')}: </span>
          {clarification.answer}
        </div>
      )}
      <ClarificationsArchiveListContainer />
    </ColumnLayout>
  );
});
